import React from 'react'
import { Toaster } from '@8x8/oxygen-toaster'
import styled from 'styled-components'
import { Z_INDEX } from '~/core/constants'

const NotificationContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: ${Z_INDEX.NOTIFICATIONS};
`

function withNotificationsHoC (Component) {
  const withNotifications = props => (
    <>
      <NotificationContainer>
        <Toaster />
      </NotificationContainer>
      <Component {...props} />
    </>
  )

  return withNotifications
}

export default withNotificationsHoC
